import styled from 'styled-components';

export const ToggleThemeContainer = styled.div`
  svg {
    &:first-of-type {
      top: 4px;
      left: 4.5px;
      font-size: 14px;
    }

    &:last-of-type {
      top: 3.5px;
      right: 4px;
      font-size: 15px;
    }
  }
`;
